import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { UserResponse, User } from "../models/user.model";
import { Observable } from "rxjs/Observable";
import { NameIdString } from "../models/nameId";
import { HttpClient } from "@angular/common/http";

const URL = environment.apiBaseUrl;

@Injectable()
export class UsersService {
  constructor(private http: HttpClient) {}

  public users(
    startRow: number,
    endRow: number,
    searchText: string,
    sortCol: string,
    sortDesc: boolean
  ): Observable<UserResponse> {
    const url =
      `${URL}users?startRow=${startRow}&endRow=${endRow}&searchString=${searchText}` +
      `&sortColumn=${sortCol}&sortDescending=${sortDesc}`;

    return this.http.get(url).map((x: any) => {
      const res = new UserResponse();
      res.users = x.data as User[];
      res.total = x.total;
      return res;
    });
  }

  public getUser(id: string): Observable<User> {
    return this.http.get<User>(`${URL}users/${id}`);
  }

  public updateUser(user: User) {
    return this.http.put(`${URL}users`, user);
  }

  public addUser(user: User) {
    return this.http.post(`${URL}users`, user);
  }

  public deactivateUser(id: string) {
    return this.http.post(`${URL}users/deactivate/${id}`, null);
  }

  public setRole(userId: string, roleId: number) {
    return this.http.post(`${URL}/users/setRole/${userId}/${roleId}`, null);
  }

  public getRole(userId: string): Observable<number> {
    return this.http.get<number>(`${URL}/users/role/${userId}`);
  }

  public getAllSimple(): Observable<NameIdString[]> {
    return this.http.get<NameIdString[]>(`${URL}/users/allSimple`);
  }

  public getAllUserAdvisorsSimple(): Observable<NameIdString[]> {
    return this.http.get<NameIdString[]>(`${URL}/users/advisorsSimple`);
  }
}
